module.exports = __webpack_public_path__ + "images/stickers/pete-award@2x.43dd35d5e48a876a50fc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-award@2x.png
// module id = HCV8
// module chunks = 2